import { Modal } from "antd";
import React from "react";

const ModalComponent = ({
  isModalVisible,
  handleOk,
  handleCancel,
  children,
  ...customStyles
}) => (
  <Modal
    visible={isModalVisible}
    onOk={handleOk}
    onCancel={handleCancel}
    footer={null}
    {...customStyles}
    centered
  >
    {children}
  </Modal>
);

export default ModalComponent;
